import * as yup from "yup";

export const schema = yup.object().shape({
    operatorCodes: yup.array().min(1, "Please select at least one operator")
        .typeError("Please select at least one operator").label('Operator'),
    roles: yup.string().required().label('Roles'),
    email: yup.string().email().required().max(100).label('Email'),
    name: yup.string().required().max(100).label('Name')
})

export function validate(formValues, schema) {
    let errors = {}
    schema._nodes.forEach((node) => {
        try {
            schema.validateSyncAt(node, formValues)
        } catch (err) {
            errors[node] = err.message
        }
    })
    return errors
}